interface ChildLinien {
  produkt?: {
    produktlinien?: Array<{ selected?: boolean; bruttopreis?: number | null }>;
  } | null;
}

export const hasPricedSelectedLinie = (child: unknown): boolean =>
  ((child as ChildLinien | undefined)?.produkt?.produktlinien ?? []).some(
    linie => Boolean(linie.selected) && linie.bruttopreis != null && linie.bruttopreis > 0,
  );

export const hasAllLinienPriced = (child: unknown): boolean => {
  const linien = (child as ChildLinien | undefined)?.produkt?.produktlinien ?? [];
  return (
    linien.some(linie => Boolean(linie.selected)) &&
    linien.every(linie => linie.bruttopreis != null && linie.bruttopreis > 0)
  );
};

export const priceOfSelectedLinie = (child: unknown): number =>
  ((child as ChildLinien | undefined)?.produkt?.produktlinien ?? []).find(linie =>
    Boolean(linie.selected),
  )?.bruttopreis ?? 0;
